module.exports = __webpack_public_path__ + "img/17.667eca06.jpg";